import { makeStyles } from '@material-ui/core/styles';

import { GENDER } from 'src/data/demographics';
import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      '& .recharts-bar-background-rectangle': {
        fill: COLORS.neutral.silver,
      },

      '&$highlightFemale': {
        [`& .recharts-bar-rectangle rect[name="${GENDER.female}"]`]: {
          fill: theme.palette.primary.main,
        },
      },

      '&$highlightMale': {
        [`& .recharts-bar-rectangle rect[name="${GENDER.male}"]`]: {
          fill: theme.palette.primary.main,
        },
      },

      '& .recharts-text': {
        fill: COLORS.neutral.mediumGray,
        fontSize: theme.typography.pxToRem(10),
      },
    },
    highlightFemale: {},
    highlightMale: {},

    labelEmpty: {
      fill: '#9FA8BD',
      fontSize: theme.typography.pxToRem(12),
    },
  }),
  { name: 'HistogramGender' }
);
